package com.siriusxm.pia.views.chat

import com.siriusxm.pia.CapabilityAction

/**
 * The chat module's unified-content (AVP) capabilities (UCA-1091).
 *
 * Actions are declared here, next to the feature they gate, rather than in a central enum in cmc-core,
 * so the chat module owns its own capability names. Each id must match the Cedar action the *server*
 * enforces for the same operation — the client only ever uses it to *hide* an affordance.
 */

/**
 * Read full chat transcripts in the unlisted chat admin UI (`#chat/transcripts`). Server-enforced on
 * `listChatTranscripts` / `getChatTranscript` via the same action id.
 */
val ViewChatTranscripts: CapabilityAction =
    CapabilityAction("UnifiedContentManagementConsole_ViewChatTranscripts")
